import React from "react";

function Cart() {
  return (
    <div
      style={{
        padding: "80px 20px",
        maxWidth: "1440px",
        margin: "0 auto",
        fontFamily: "Inter, sans-serif",
        textAlign: "center",
      }}
    >
      <h1
        style={{
          fontSize: "3rem",
          fontWeight: "700",
          color: "#1a2e1a",
          marginBottom: "20px",
          fontFamily: "Playfair Display, serif",
        }}
      >
        Shopping Cart
      </h1>
      <div
        style={{
          background: "#f8faf8",
          padding: "60px 40px",
          borderRadius: "20px",
          margin: "40px 0",
        }}
      >
        <p
          style={{
            fontSize: "1.2rem",
            color: "#666",
            marginBottom: "30px",
          }}
        >
          Your cart is currently empty
        </p>
        <button
          style={{
            background: "linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)",
            border: "none",
            borderRadius: "50px",
            padding: "16px 32px",
            color: "white",
            fontSize: "1rem",
            fontWeight: "600",
            cursor: "pointer",
            transition: "all 0.3s ease",
          }}
        >
          Start Shopping
        </button>
      </div>
    </div>
  );
}

export default Cart;
